import { Building2, UserCircle, ChevronRight, LogOut } from "lucide-react";
import { isClientOnlyForAllDistros } from "../../utils/firmAccess";

const roles = [
    {
        key: "owner",
        label: "View Firm Portal",
        subtitle: "Manage accounts, view financials, and oversee advisors",
        icon: Building2,
    },
    {
        key: "advisor",
        label: "View Advisor Portal",
        subtitle: "View your clients, marketing materials, and enrollment tools",
        icon: UserCircle,
    },
];

const CLIENT_ONLY_OWNER_SUBTITLE = "View clients, marketing, and enrollment tools for the full firm";

const RoleSelector = ({ onSelectRole, userName, onSignOut, distros }) => {
    const allClientOnly = isClientOnlyForAllDistros({ distros });
    return (
        <div className="flex flex-col justify-center items-center w-full max-w-xl mx-auto bg-white p-8 shadow-card rounded-2xl my-16">
            <div className="w-full space-y-5">
                {/* header */}
                <div className="text-center">
                    <h4 className="text-2xl md:text-3xl font-bold text-gray-900">
                        Welcome{userName ? `, ${userName}` : ""}
                    </h4>
                    <p className="text-sm text-gray-500 mt-1">
                        How would you like to sign in?
                    </p>
                </div>

                {/* role options */}
                <div className="space-y-2">
                    {roles.map(({ key, label, subtitle: defaultSubtitle, icon: Icon }) => {
                        const subtitle = key === "owner" && allClientOnly ? CLIENT_ONLY_OWNER_SUBTITLE : defaultSubtitle;
                        return (
                        <button
                            key={key}
                            onClick={() => onSelectRole(key)}
                            className="w-full flex items-center gap-3 p-4 bg-gray-50 border border-gray-200 rounded-xl hover:bg-primary/5 hover:border-primary/30 transition-all duration-200 group"
                        >
                            <div className="p-2 rounded-lg bg-white group-hover:bg-primary/10 transition-colors">
                                <Icon className="w-5 h-5 text-gray-400 group-hover:text-primary transition-colors" />
                            </div>
                            <div className="flex-1 text-left">
                                <span className="block text-base font-medium text-gray-900 group-hover:text-primary transition-colors">
                                    {label}
                                </span>
                                <span className="block text-sm text-gray-500">
                                    {subtitle}
                                </span>
                            </div>
                            <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-primary transition-colors" />
                        </button>
                        );
                    })}
                </div>

                {/* sign out */}
                {onSignOut && (
                    <div className="pt-4 border-t border-gray-100 mt-2">
                        <button
                            onClick={onSignOut}
                            className="flex items-center justify-center gap-2 w-full py-2 text-sm text-gray-400 hover:text-gray-600 transition-colors"
                        >
                            <LogOut className="w-4 h-4" />
                            <span>Sign out</span>
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default RoleSelector;
